// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3arDQ","productName":"Table_productName__9sPjg"};